import { configureStore } from '@reduxjs/toolkit'
import orderReducer from './orderSlice'
import userReducer from './userSlice'
import badgeReducer from './BadgeStatusSlice'
import taskStatusReducer from './TaskStatusSlice'
import TaskTypeReducer from './TaskTypeSlice'
import AllUsersReducer from './AllUserSlice'
import AllProductsReducer from './ProductSlice'

 const store = configureStore({
  reducer: {
    order: orderReducer,
    user:userReducer,
    badge: badgeReducer,
    taskStatus: taskStatusReducer,
    taskType: TaskTypeReducer,
    allUsers: AllUsersReducer,
    products: AllProductsReducer,
  }
})



export type RootState= ReturnType<typeof configureStore>
export type AppDispatch = ReturnType<typeof store.dispatch>
export default store